:host {
  display: flex;
  flex-direction: column;
  max-width: 100%;
  padding: 0 0 0 calc(var(--spacer) * 2);
}

gz-labeled-content::part(label) {
  width: 25%;
  display: flex;
  align-items: center;
}

gz-labeled-content::part(content) {
  width: 75%;
}

.row-name {
  max-width: 280px;
}

.text-gray {
  color: var(--chart-300-icon-buttons);
}

.border {
  border-style: solid;
}

.check-result {
  margin-right: 4px;
}

#complianceLearnMoreSideMenuButton {
  margin-top: var(--spacer);
}

.compliance-content-max-width {
  max-width: 300px;
}
